import React, {useMemo} from 'react';

import {usePlotAddressLine} from '~utils/plot/address';
import {PlotDetailsResponse} from '~types/Plots';
import {Label} from '~atoms/Text';
import {dmsCoordinates} from '~utils/plot/coordinates';
import {If} from '~atoms/If';

import {Wrapper} from './styles';

type PlotAddressProps = {
    plot?: PlotDetailsResponse;
};

const PlotAddress: React.FC<PlotAddressProps> = ({plot}) => {
    const center = useMemo(() => dmsCoordinates(plot?.center || [0, 0]), [plot]);
    const address = usePlotAddressLine(plot);

    return (
        <Wrapper>
            <Label>
                <If condition={address}>
                    {address}
                    <br />
                </If>
                {center}
            </Label>
        </Wrapper>
    );
};

export default PlotAddress;
